export default __webpack_public_path__ + "8f6ab487bdd559e01fcaa5ecf3f52b27.png";